export function validatePhoneNumber(value: string): boolean {
  const regex = /^\+?[\d\s]*(\([\d\s]*\))?[\d ]{0,30}$/;
  return value.match(regex) !== null;
}
